import {
  ActivityStatus,
  QuestionTypes,
} from '@showbie-socrative/socrative-utils';

import { sendQuestionViewClickEvent } from '../';
import { EventAdapter } from './EventAdapter';

export type QuestionType = QuestionTypes;
export type ActivityState = 'live' | 'finished' | 'paused' | 'unknown';

interface QuestionViewClickEventPayload {
  question_type: QuestionType;
  activity_state: ActivityState;
}

export class QuestionViewEventAdapter extends EventAdapter<QuestionViewClickEventPayload> {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendQuestionViewClickEvent;

  constructor(payload: QuestionViewClickEventPayload) {
    super();
    this.eventData = payload;
  }

  static getActivityStateForEvent(state: ActivityStatus): ActivityState {
    switch (state) {
      case ActivityStatus.Running:
        return 'live';
      case ActivityStatus.Paused:
        return 'paused';
      case ActivityStatus.Finished:
        return 'finished';
      default:
        return 'unknown';
    }
  }
}
